var render, staticRenderFns
import script from "./TransferPage.vue?vue&type=script&lang=js&"
export * from "./TransferPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005a54b9')) {
      api.createRecord('005a54b9', component.options)
    } else {
      api.reload('005a54b9', component.options)
    }
    
  }
}
component.options.__file = "pc/views/TransferPage.vue"
export default component.exports